import React from 'react';
import { AnimatePresence } from 'framer-motion';
import {
  useRouteMatch,
  useLocation,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import routes from 'routes';
import AdminOnlyRoute from 'components/RouteGuards/AdminOnlyRoute';
import AuthenticatedOnlyRoute from 'components/RouteGuards/AuthenticatedOnlyRoute';
import UnauthenticatedOnlyRoute from 'components/RouteGuards/UnauthenticatedOnlyRoute';
import AppMenu from 'components/AppMenu';
import ErrorPage from './ErrorPage';
import { useHasura } from 'context/ApiState';
import { useNavigate, routeMap } from 'routeMap';
import Button from './Button';
import Auth from '@aws-amplify/auth';
import { useAuthWrapperContext } from 'toolbox/src/components/AuthWrapper/AuthWrapper';

const AppLayout = () => {
  const { refreshAuthState } = useAuthWrapperContext();
  const { path } = useRouteMatch();
  const { organisations } = useHasura();

  const location = useLocation();
  const navigate = useNavigate();

  if (organisations?.length < 1)
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-500">
        <p>You do not have permission to access any Organisations.</p>
        <p>Please contact JCAP.</p>
        <form>
          <Button
            type="button"
            autoFocus
            className="mt-3 btn"
            onClick={() => window.location.reload()}
          >
            Refresh
          </Button>
          <Button
            type="button"
            className="mt-3 btn btn-danger"
            onClick={() =>
              Auth.signOut()
                .then(() => refreshAuthState())
                .then(() => window.location.reload())
            }
          >
            Sign Out
          </Button>
        </form>
      </div>
    );

  return (
    <div className="fixed inset-0 flex flex-col overflow-hidden md:flex-row">
      {!location.pathname.startsWith(routeMap.authenticatorRoot()) && (
        <AppMenu />
      )}

      <Switch location={location} key={path}>
        {routes.map(
          (
            {
              path,
              component,
              authenticatedOnly = false,
              unauthenticatedOnly = false,
              exact = false,
              adminOnly = false,
            },
            i,
          ) => {
            if (adminOnly)
              return (
                <AdminOnlyRoute
                  key={i}
                  path={path}
                  exact={exact}
                  component={component}
                />
              );
            if (authenticatedOnly)
              return (
                <AuthenticatedOnlyRoute
                  key={i}
                  path={path}
                  exact={exact}
                  component={component}
                />
              );
            if (unauthenticatedOnly)
              return (
                <UnauthenticatedOnlyRoute
                  key={i}
                  path={path}
                  exact={exact}
                  component={component}
                />
              );
            return (
              <Route key={i} path={path} exact={exact} component={component} />
            );
          },
        )}
        <Route path="*">
          <ErrorPage overrideType="404" />
        </Route>
      </Switch>
    </div>
  );
};

export default AppLayout;
